import { useEffect } from 'react'
import useUpdateUserProfile from "service-hooks/useUpdateUserProfile";
import TextInput from "components/TextInput";
import useCurrentUser from 'hooks/useCurrentUser';
import C from "Constants";
import { t } from 'i18next';
import { SlideInFooter } from 'components/layouts/SlideInLayout';
import { CustomButton } from 'components/Button';

//TODO: Edit Profile page is not working, need to fix it,
//use the following code once issue is fixed

{/* <WithLoading>
<div>
  <PageHeaderV2
    headerStyleProps={{
      className: "p-6",
      style: {
        zIndex: 100,
      },
    }}
    pageTitle={"Edit Profile"}
    hideAuth={true}
  />
  <br />
  <br />
  <br />
  <div className='p-6 mt-3 flex flex-col gap-4'>
   

  </div>
</div>
</WithLoading> */}

const EditUserProfile = ({setUserInfoModal=()=>{}, isOpenUserInfoModal=false}) => {
  const { formstate, onFinish, updateFormState } = useUpdateUserProfile({
    setUserInfoModal,
    isOpenUserInfoModal,
  });

  const { currentUser } = useCurrentUser();

  const { values, errors } = formstate;
  const { name, email, loading: isLoading, error } = values;

  const stopClickPropagation = (e) => e.stopPropagation();

  useEffect(() => {
    if (currentUser) {
      updateFormState("name", currentUser?.user?.name);
      updateFormState("email", currentUser?.user?.email);
    }
  }, [currentUser]);


  return (
    <>
    <form className='flex flex-col gap-4 justify-center items-center p-6 mt-3' 
        id="editUserProfileForm">
      {/* profile image */}
      {/* <div className='relative w-110x h-110x rounded-30x'>
        <img src={values?.profileImage ?? C.PLACEHODERIMAGE} alt={values?.name} className='rounded-30x' />
        <button className="outline-none border-none absolute w-full flex justify-center items-center" style={{ bottom: "-10px" }}>
          <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="1" width="34" height="34" rx="17" fill="#F3F4F6" />
            <rect x="1.5" y="1" width="34" height="34" rx="17" stroke="#F9FAFB" stroke-width="2" />
            <g clip-path="url(#clip0_175_6139)">
              <path d="M23 25.0834H14C12.35 25.0834 11 23.7418 11 22.1001V16.1334C11 14.4918 12.35 13.1501 14 13.1501H15.0917C15.35 13.1501 15.5833 13.0167 15.725 12.8084L16.7167 11.2584C16.8583 11.0418 17.0917 10.9167 17.35 10.9167H19.5833C19.8333 10.9167 20.0667 11.0418 20.2083 11.2418L21.2833 12.8251C21.425 13.0334 21.6583 13.1501 21.9083 13.1501H23.0083C24.6583 13.1501 26.0083 14.4918 26.0083 16.1334V22.1001C26.0083 23.7418 24.6583 25.0834 23.0083 25.0834H23Z" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M18.5 21.375C19.5355 21.375 20.375 20.5355 20.375 19.5C20.375 18.4645 19.5355 17.625 18.5 17.625C17.4645 17.625 16.625 18.4645 16.625 19.5C16.625 20.5355 17.4645 21.375 18.5 21.375Z" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M23 16.125H21.5" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_175_6139">
                <rect width="20" height="20" fill="white" transform="translate(8.5 8)" />
              </clipPath>
            </defs>
          </svg>

        </button>
      </div> */}
      {/* input fields */}
      {error && (
        <div className="text-red-500 text-center mb-4">
          {error}
        </div>
      )}
      <div className='flex flex-col gap-2 w-full'>
        <TextInput
          label={t("Name")}
          value={name}
          onChange={(e) => updateFormState("name", e.target.value)}
          name="mapAddress"
          mandatory={true}
          labelClasses="text-12x font-normal text-shadow-forge-700"
          inputClasses="focus:outline-none mb-4 flex-1 text-14x font-bold text-dark-blue-900 block w-full rounded border-b pb-2 border-gray-200"
          placeHolder={t("Your Name")}
          readOnly={false}
          error={errors.name}
        />
      </div>
      <div className='flex flex-col gap-2 w-full'>
        <TextInput
          label={t("Email")}
          value={email}
          onChange={(e) => updateFormState("email", e.target.value)}
          name="mapAddress"
          mandatory={false}
          labelClasses="text-12x font-normal text-shadow-forge-700"
          inputClasses="focus:outline-none mb-4 flex-1 text-14x font-bold text-dark-blue-900 block w-full rounded border-b pb-2 border-gray-200 "
          placeHolder={t("Email Address")}
          readOnly={false}
          error={errors?.email}
        />
      </div>
      {/* {renderButton()} */}
    </form>
      <SlideInFooter>
        <CustomButton /* form="editUserProfileForm" */ type="submit" onClick={isLoading ? stopClickPropagation : onFinish}
        className={isLoading ? "blinking-login-header":""}
        disabled={isLoading}>{isLoading ? t("Saving ...") : t("Save")}</CustomButton>
      </SlideInFooter>
      </>
  )
}

export default EditUserProfile